import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";

const Hero = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-flow: row wrap;
  padding: 20px 40px 20px 40px;
  position: relative;
  width: 100%;
  max-width: 100vw;
  @media (max-width: 810px) {
    height: auto;
    max-width: 810px;
  }
  @media (max-width: 440px) {
    height: auto;
    padding: 20px;
    margin-bottom: 60px;
  }
`;
const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  max-width: 693px;
  padding: 40px;
  height: 588px;
  justify-content: center;
  align-items: flex-start;
  background-color: #ededed;
  @media (max-width: 810px) {
    height: 388px;
    width: 50%;
  }
  @media (max-width: 440px) {
    height: auto;
    width: 100%;
    background-color: transparent;
    padding: 0;
  }
`;
const FullWidthContentBox = styled.div`
  position: absolute;
  top: 0;
  left: 60px;
  display: flex;
  flex-direction: column;
  width: 40%;
  max-width: 693px;
  padding: 40px;
  height: 588px;
  justify-content: center;
  align-items: flex-start;
  background-color: transparent;
  @media (max-width: 810px) {
    height: 388px;
  }
  @media (max-width: 440px) {
    height: auto;
    padding: 0;
    top: 70px;
    left: 35px;
    width: 55%;
  }
`;
const Title = styled.h1`
  font-size: 3rem;
  font-weight: 400;
  text-align: left;
  letter-spacing: 2;
  line-height: inherit;
  color: ${(props) =>
    props.textColor && props.textColor === "white" ? "#fff" : "#101010"};
  @media (max-width: 810px) {
    font-size: 1.6rem;
    line-height: 38px;
  }
`;
const Ingress = styled.div`
  font-size: ${(props) =>
    props.heroLayout && props.heroLayout === "full-width" ? "1.1rem" : "1rem"};
  max-width: 350px;
  color: ${(props) =>
    props.textColor && props.textColor === "white" ? "#fff" : "#000"};
  @media (max-width: 810px) {
    font-weight: 300;
    font-size: 0.9rem;
    line-height: inherit;
  }
`;
const Button = styled((props) => <Link {...props} />)`
  width: 100%;
  max-width: 165px;
  background-color: #101010;
  color: #fff;
  text-decoration: none;
  transition: 0.3s ease-in-out;
  border-radius: 5px;
  padding: 15px 10px 15px 25px;
  display: flex;
  align-items: center;
  &:visited {
    color: #fff;
  }
  &:hover {
    color: #fff;
  }
  &:hover svg {
    color: #fff;
    width: 55px;
    padding-left: 15px;
  }
  @media (max-width: 810px) {
    padding: 12px;
    max-width: 140px;
  }
`;
const Icon = styled((props) => <ArrowRightAltIcon {...props} />)`
  padding-left: 0;
  transition: all 0.3s ease-in-out !important;
  color: #101010;
  width: 0;
  font-size: 1.8rem;
  margin-bottom: 3px;
  @media (max-width: 810px) {
    font-size: 1.7rem !important;
    color: #fff;
    width: 40px !important;
    padding-left: 10px;
  }
`;
const Img = styled(ImageLibpixel)`
  width: 60%;
  max-width: 1065px;
  object-fit: cover;
  height: 588px;
  padding-right: 20px;
  @media (max-width: 810px) {
    height: 388px;
    width: 50%;
  }
  @media (max-width: 440px) {
    height: 250px;
    width: 100%;
    padding-right: 0;
    padding-bottom: 20px;
  }
`;
const FullWidthImg = styled(ImageLibpixel)`
  width: 100%;
  object-fit: cover;
  height: 588px;
  @media (max-width: 810px) {
    height: 388px;
  }
  @media (max-width: 440px) {
    height: 370px;
    width: 100%;
  }
`;

const Hero2 = ({
  description,
  heroLayout,
  imgSrc,
  links,
  textColor,
  title,
}) => {
  return (
    <>
      {heroLayout && heroLayout === "full-width" ? (
        <Hero>
          <FullWidthImg
            src={imgSrc
              ?.replace("localhost:8000", "")
              .replace("/wp-content/uploads", "static.enklerevalg.no")}
            alt={_("kunde bild")}
          />
          <FullWidthContentBox>
            <Title textColor={textColor}>{title}</Title>
            <Ingress
              textColor={textColor}
              heroLayout={heroLayout}
              dangerouslySetInnerHTML={{ __html: description }}
            ></Ingress>
            {links?.map((link, i) => (
              <Button
                key={i}
                to={link.link.url.replace("http://enkle.re/MEV-DEV", "")}
              >
                {link.linkTitle}
                <Icon />
              </Button>
            ))}
          </FullWidthContentBox>
        </Hero>
      ) : (
        <Hero>
          <Img
            src={imgSrc
              ?.replace("localhost:8000", "")
              .replace("/wp-content/uploads", "static.enklerevalg.no")}
            alt={_("kunde bild")}
          />
          <ContentBox>
            <Title textColor={textColor}>{title}</Title>
            <Ingress
              textColor={textColor}
              heroLayout={heroLayout}
              dangerouslySetInnerHTML={{ __html: description }}
            ></Ingress>
            {links?.map((link, i) => (
              <Button
                key={i}
                to={link.link.url.replace("http://enkle.re/MEV-DEV", "")}
              >
                {link.linkTitle}
                <Icon />
              </Button>
            ))}
          </ContentBox>
        </Hero>
      )}
    </>
  );
};

Hero2.propTypes = {
  description: PropTypes.string,
  heroLayout: PropTypes.string,
  imgSrc: PropTypes.string,
  links: PropTypes.array,
  textColor: PropTypes.string,
  title: PropTypes.string,
};

Hero2.defaultProps = {
  description: undefined,
  heroLayout: undefined,
  imgSrc: undefined,
  links: undefined,
  textColor: undefined,
  title: undefined,
};

export default Hero2;
